
import Blur from 'vux/src/components/blur/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import { removeToken } from '@/utils/storage'

export default {
components: {
Blur,
XHeader,
Card,
Divider,
Cell,
CellFormPreview,
CellBox,
Badge,
Group,
Loading
},
data () {
return {
store_name: '',
store_logo: require('../../assets/store_logo.png'),
today_order_count: 0,
today_order_amount: 0,
yesterday_order_count: 0,
yesterday_order_amount: 0,
goods_count: 0
}
},
created () {
this.$vux.loading.show({
text: '加载中...'
})
this.$store.dispatch('getSellerInfo').then((res) => {
const seller = res.data
this.store_name = seller.store_name
if (seller['store_logo']) {
this.store_logo = seller.store_logo
}
if (seller.today_order_count) {
this.today_order_count = seller.today_order_count
}
if (seller.today_order_amount) {
this.today_order_amount = seller.today_order_amount
}
if (seller.yesterday_order_count) {
this.yesterday_order_count = seller.yesterday_order_count
}
if (seller.yesterday_order_amount) {
this.yesterday_order_amount = seller.yesterday_order_amount
}
if (seller.goods_count) {
this.goods_count = seller.goods_count
}
this.$vux.loading.hide()
}).catch((err) => {
console.log(err)
this.$vux.loading.hide()
})
},
methods: {
doListGoods () {
this.$router.push({path: '/goods/goods_list'})
},
orderList () {
this.$router.push({path: '/order/order_list'})
},
updatePassword () {
this.$router.push({path: '/user/reset_pwd'})
},
doLogout () {
removeToken()
this.$router.push({path: '/login/index'})
}
}
}



// WEBPACK FOOTER //
// ./src/components/user/User.vue